var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklesSoftFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkles-soft"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0202 3.32301C20.5958 2.89072 20.3255 2.25667 20.222 1.37008V1H19.445V1.36968C19.3379 2.27111 19.0676 2.89103 18.6461 3.31259C18.2245 3.73415 17.6046 4.00442 16.7032 4.11154H16.3335V4.88846H16.7036C17.5902 4.99203 18.2242 5.26226 18.6565 5.68673C19.0872 6.10963 19.3628 6.73014 19.445 7.62517V8H20.222V7.62473C20.3009 6.74444 20.5763 6.10989 21.0098 5.67634C21.4434 5.24278 22.0779 4.96737 22.9582 4.88846H23.3335V4.11154H22.9587C22.0636 4.02931 21.4431 3.7537 21.0202 3.32301Z",
    fill: "#166D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 14C5.33643 14 7.27037 14.6636 8.47014 15.8634C9.66991 17.0631 10.3335 18.9971 10.3335 22H12.3335C12.3335 18.9971 12.9971 17.0631 14.1969 15.8634C15.3966 14.6636 17.3306 14 20.3335 14V12C17.3306 12 15.3966 11.3364 14.1969 10.1366C12.9971 8.93688 12.3335 7.00293 12.3335 4H10.3335C10.3335 7.00293 9.66991 8.93688 8.47014 10.1366C7.27037 11.3364 5.33643 12 2.3335 12V14Z",
    fill: "#166D7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesSoftFilled);
export default __webpack_public_path__ + "static/media/sparkles-soft-filled.96a27250ed370934f2396654afe3779d.svg";
export { ForwardRef as ReactComponent };